export default {
    UPDATE_DOD_AUTHORIZATION_FIELD: 'UPDATE_DOD_AUTHORIZATION_FIELD',
    UPDATE_DOD_AUTHORIZATION_TITLE: 'UPDATE_DOD_AUTHORIZATION_TITLE',
    STORE_DOD_AUTHORIZATION_DESIGNEE_REFERENCE: 'STORE_DOD_AUTHORIZATION_DESIGNEE_REFERENCE'
}
